// Keep this file in sync with internal/topic/preview.go.

import type { Topic } from './types';
import { formatTopicDate, formatTopicDateTimeLines } from './datetime';
import { TopicLogic } from './logic';

const fallbackPreviewImagePath = '/images/logo512.png';

export interface Preview {
  type: string;
  title: string;
  description: string;
  image: string;
  url: string;
}

export function newPreview(
  topic: Topic | null | undefined,
  appBaseURL: string,
  serverBaseURL: string
): Preview {
  const preview: Preview = {
    type: 'website',
    title: 'Snowball Topic',
    description: 'View this topic on Snowball.',
    image: `${serverBaseURL}${fallbackPreviewImagePath}`,
    url: '',
  };

  if (!topic) {
    return preview;
  }

  const topicPath = `/topics/${encodeURIComponent(topic.id)}`;
  preview.url = `${appBaseURL}${topicPath}`;

  const title = topic.title.trim();
  if (title) {
    preview.title = `${title}\n${formatTopicDate(
      TopicLogic.startTimeAsDateObj(topic),
      topic.timezone
    )}`;
  }

  preview.description = formatTopicDateTimeLines(topic, undefined, true).join(
    '\n'
  );

  if (topic.imageData?.trim()) {
    preview.image = `${serverBaseURL}${topicPath}/image`;
  }

  return preview;
}
